// -- other --
import React, { Suspense, lazy, useState,useEffect } from 'react';
import ImageWithBasePath from "../../../core/img";
import {Link} from "react-router-dom";
import {all_routes} from "../../router/all_routes";
// -- biz9 --
import {UrlParam} from "biz9-react-utility";
import {UrlQuery} from "biz9-react-utility";
import {Log,Num,Str,DateTime,Response_Logic} from "biz9-utility";
import {Data_Logic} from "biz9-data-app";
import {Image_Format} from "biz9-image";
import {Config,Field,Message,Title,Type,Url} from "../../../constant";
import {App,Data,Dashboard,Event,Field_Logic,Image,Style,Service_Industry,Template,Toast_Message,Storage,System,User} from "../../../project";

import SubValue from "../../subValue";
import {Portal_Type,Portal_Field,Portal_Table,Portal_Stat,Portal_Page,Sub_Value_Logic,Portal_Url,Portal_Value_Type,Portal_Remote_Page,Portal_Remote_Data,Sub_Value_Type} from "biz9-portal-app";

const Gallery_Detail = () => {
    /* -- DEFINE -- *
     * --- PAGE-FIELDS ---
     *  gallery
     *  - challenge - string
     *  - project_scope - string
     *  - client - string
     *  - website - string
     *  - date - string
     *  - industry - string
     *  - solution - string
     *  - solution_1 - string
     *  - solution_2 - string
     *  - solution_3 - string
     *  - outcome - string
     *  - outcome_1 - string
     *  - outcome_2 - string
     *  - outcome_3 - string
     */
    const query = UrlQuery();
    const param = UrlParam();
    // -- page-edit --
 const [sub_value_edit,setSubValueEdit] = useState(Sub_Value_Logic.get_sub_value_edit(Portal_Table.PAGE,0));
 const [page,setPage] = useState(Data_Logic.get(Portal_Table.PAGE,0));
 const [sub_value_group,setSubValueGroup] = useState(Sub_Value_Logic.get_test_sub_value_group({count:50,show_value:false}));
 const [edit_mode,setEditMode] = useState(false);
// -- main --
    const [val_title_url,setValTitleUrl] = useState(null);
	const [gallery, setGallery] = useState(Data_Logic.get(Portal_Table.GALLERY,0));

 useEffect(() => {
        Toast_Message.loading(Message.LOADING);
        get_page_data();
    }, []);

 useEffect(() => {
        Toast_Message.loading(Message.LOADING);
        if(param.title_url){
            get_items_data(param.title_url);
        }
        }, [param.title_url]);

     async function get_page_data() {
        // -- remote-data-response --
        let option = {get_cache:false,time_limit:10};
        const [response,data] = await Portal_Remote_Page.get(App.get_url(Portal_Url.PAGE_GET),Portal_Page.HOME.title_url,option);
        bind_page(data);
    };
    async function get_items_data(title_url) {
        // -- remote-data-response --
        let option = {get_cache:false,time_limit:10};
        const [response,data] = await Portal_Remote_Page.get_gallery_items(App.get_url(Portal_Page.GALLERY[Portal_Type.ITEMS_URL]),title_url,option);
        Log.w('111',response);
        Log.w('111',data);
        bind_items(title_url,data);
        Toast_Message.dismiss();
    }
       async function bind_page(data) {
         // -- page-template --
        setPage(data[Portal_Type.PAGE]);
        // -- page-edit --
        setEditMode(query.get('edit_mode'));
        setSubValueEdit(Sub_Value_Logic.get_sub_value_edit(Portal_Table.PAGE,data[Portal_Type.PAGE].id));
        // -- sub-values --
        bind_sub_values(data[Portal_Type.SUB_VALUE_GROUP]);
   }
    async function bind_items(title_url,data) {
        // -- title_url --
        setValTitleUrl(title_url);
        // -- gallerys --
        Log.w('33_data',data[Portal_Type.GALLERY]);
        setGallery(data[Portal_Type.GALLERY]);
    }
    async function bind_sub_values(data_sub_group) {
        // -- sub-values --
        for(const sub_group in data_sub_group){
            if(data_sub_group[sub_group].type != Sub_Value_Type.ITEMS){
                sub_value_group[Portal_Type.SUB_VALUE_UNDER_SCORE+data_sub_group[sub_group].value_id].value = data_sub_group[sub_group].value;
            }else{
                sub_value_group[Portal_Type.SUB_VALUE_UNDER_SCORE+data_sub_group[sub_group].value_id].items = data_sub_group[sub_group].items;
            }
        }
        Storage.post_sub_value_group(sub_value_edit,data_sub_group);
    };

     async function update_sub_value(sub_value) {
        // -- page-edit-sub-values --
        if(sub_value.type != Sub_Value_Type.ITEMS){
            setSubValueGroup(sub_value_group => ({
                ...sub_value_group,
                    [Portal_Type.SUB_VALUE_UNDER_SCORE+sub_value.value_id]: {
                    ...sub_value_group[Portal_Type.SUB_VALUE_UNDER_SCORE+sub_value.value_id],
                    value: sub_value.value
                }
            }));
        }else{
            setSubValueGroup(sub_value_group => ({
                ...sub_value_group,
                    [Portal_Type.SUB_VALUE_UNDER_SCORE+sub_value.value_id]: {
                    ...sub_value_group[Portal_Type.SUB_VALUE_UNDER_SCORE+sub_value.value_id],
                    items: sub_value.items
                }
            }));
        }
    }

   return (
    <div>
      <>
        {/* Breadcrumb */}
        <div className="breadcrumb-bar">
          <div className="breadcrumb-img">
            <div className="breadcrumb-left">
              <ImageWithBasePath src="/assets/img/bg/banner-bg-03.png" alt="img" />
            </div>
          </div>
          <div className="container">
            <div className="row">
              <div className="col-md-12 col-12">
                <nav aria-label="breadcrumb" className="page-breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to={all_routes.home}>Home</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to={all_routes.gallery}>Portfolio</Link>
                    </li>
                  </ol>
                </nav>
                <h2 className="breadcrumb-title">
                        {"Portofolio Detail"}
                         </h2>
              </div>
            </div>
          </div>
        </div>
        {/* /Breadcrumb */}
        {/* Page Content */}
        <div className="page-content">
          <div className="container">
            <div className="row">
              {/* Portfolio Details */}
              <div className="col-lg-12">
                <div className="portfolio-details">
                  <div className="portfolio-detail-img">
                    <ImageWithBasePath
                      src={Image.get_url(gallery.image_filename,Image_Format.SQUARE_LARGE)}
                      className="img-fluid"
                      alt="img"
                    />
                  </div>
                  <div className="portfolio-header">
                    <h2>{gallery.title}</h2>
                    <span className="badge bg-primary-light">
                      {gallery.title}
                      </span>
                  </div>
                  <div className="portfolio-contents">
                    <div className="row">
                      <div className="col-lg-8">
                        <div className="portfolio-scope">
                          <h5>Challenge</h5>
                          <p>
                          {gallery.challenge}
                          </p>
                        </div>
                        <div className="portfolio-scope">
                          <h5>Project Scope</h5>
                          <p>
                            {gallery.project_scope}
                          </p>
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="portfolio-info">
                          <div className="row">
                            <div className="col-md-6">
                              <div className="portfolio-box">
                                <h6>Client:</h6>
                                <p>{gallery.client}</p>
                              </div>
                              <div className="portfolio-box">
                                <h6>Website:</h6>
                                <p>{gallery.website}</p>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="portfolio-box">
                                <h6>Date:</h6>
                                <p>{gallery.date}</p>
                              </div>
                              <div className="portfolio-box">
                                <h6>Category:</h6>
                                <p>{gallery.industry}</p>
                              </div>
                            </div>
                            <div className="portfolio-social">
                              <h6>Share Project:</h6>
                              <ul className="social-icon">
                                <li>
                                  <Link to="#">
                                    <i className="feather icon-facebook" />
                                  </Link>
                                </li>
                                <li>
                                  <Link to="#">
                                    <i className="feather icon-twitter" />
                                  </Link>
                                </li>
                                <li>
                                  <Link to="#">
                                    <i className="feather icon-instagram" />
                                  </Link>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="portfolio-scope">
                      <h5>Solution</h5>
                      <p>
                      {gallery.solution}
                      </p>
                      <ul>
                        <li>
                          {gallery.solution_1}
                        </li>
                        <li>
                          {gallery.solution_2}
                        </li>
                        <li>
                          {gallery.solution_3}
                        </li>
                      </ul>
                    </div>
                    <div className="portfolio-scope">
                      <h5>Outcome</h5>
                      <p>
                      {gallery.outcome}
                       </p>
                      <ul>
                        <li>
                          {gallery.outcome_1}
                        </li>
                        <li>
                          {gallery.outcome_2}
                        </li>
                        <li>
                          {gallery.outcome_3}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              {/* /Portfolio Details */}
            </div>
          </div>
        </div>
        {/* /Page Content */}
      </>
    </div>
  );
};

export default Gallery_Detail;
